<template>
  <v-card class="welcome-card mb-6" elevation="0">
    <div class="welcome-accent" />
    <v-card-text class="pa-6">
      <v-row align="center">
        <v-col cols="12" md="7">
          <div class="welcome-heading mb-2">Bienvenue dans votre espace d'inscription Hublot</div>
          <p class="welcome-text mb-3">
            Merci d'avoir choisi Hublot. Pour finaliser le paramétrage de votre tablette,
            nous avons besoin de quelques informations concernant votre magasin.
            <br /><span class="welcome-hint"><v-icon x-small color="grey" class="mr-1">info</v-icon>Toutes les données pourront être modifiées directement sur votre tablette.</span>
          </p>
          <div class="d-flex align-center mt-3">
            <span class="enroll-label mr-2">Code d'inscription :</span>
            <v-chip color="primary" dark label class="enroll-code-chip font-weight-bold px-4">
              {{ enrollId || '—' }}
            </v-chip>
          </div>
        </v-col>
        <v-col cols="12" md="5" class="d-flex justify-end">
          <template v-if="loading">
            <v-card outlined class="store-card pa-4" elevation="0" style="width:100%;max-width:260px">
              <div class="d-flex align-center mb-3">
                <v-skeleton-loader type="avatar" class="mr-3" />
                <div style="flex:1">
                  <v-skeleton-loader type="text" width="120" class="mb-1" />
                  <v-skeleton-loader type="chip" width="80" />
                </div>
              </div>
              <v-skeleton-loader type="image" height="24" width="80" />
            </v-card>
          </template>
          <v-card v-else-if="enrollId" outlined class="store-card pa-4" elevation="0">
            <div class="d-flex align-center mb-2">
              <v-avatar color="primary" size="36" class="mr-3">
                <v-icon dark small>store</v-icon>
              </v-avatar>
              <div>
                <div class="store-name">{{ client.enseigne }} {{ client.name }}</div>
                <v-chip x-small :color="client.state === 'Completed' ? 'success' : 'secondary'" dark class="mt-1">
                  {{ client.state | state }}
                </v-chip>
              </div>
            </div>
            <v-img v-if="client.logo" :src="'./logos' + client.logo" max-width="80" class="mt-2" />
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'WelcomeCard',
  props: {
    enrollId: { type: [Number, String], default: null },
    client: { type: [Object, Array], default: () => ({}) },
    loading: { type: Boolean, default: false },
  },
  filters: {
    state (value) {
      return value === 'Completed' ? 'Inscription terminée' : value
    },
  },
}
</script>

<style scoped lang="scss">
@import '@/assets/vars.scss';

.welcome-card {
  border-radius: 14px !important;
  border: 1px solid #dde5ea !important;
  background: white;
  overflow: hidden;
  position: relative;
}
.welcome-accent {
  position: absolute;
  top: 0;
  left: 0;
  width: 6px;
  height: 100%;
  background: linear-gradient(180deg, var(--v-primary-base) 0%, var(--v-secondary-base) 100%);
  border-radius: 14px 0 0 14px;
}
.welcome-heading {
  font-size: 1.18rem;
  font-weight: 700;
  color: var(--v-primary-base);
  line-height: 1.4;
}
.welcome-text {
  color: rgba(0,0,0,0.72);
  font-size: 0.96rem;
  line-height: 1.65;
}
.welcome-hint {
  color: rgba(0,0,0,0.45);
  font-size: 0.85rem;
  display: inline-flex;
  align-items: center;
}
.enroll-label {
  color: rgba(0,0,0,0.55);
  font-size: 0.9rem;
}
.enroll-code-chip {
  font-size: 1rem !important;
  letter-spacing: 0.1em;
}
.store-card {
  border-radius: 10px !important;
  border-color: color-mix(in srgb, var(--v-secondary-base) 40%, transparent) !important;
  min-width: 200px;
}
.store-name {
  font-weight: 700;
  font-size: 1rem;
  color: var(--v-primary-base);
  line-height: 1.2;
}
</style>
